
export const generateDayTypeColor = (dayType) => {
  let eventColor;
  if (dayType.sickPay) {
    eventColor = "#00ff00";
  } else if (dayType.allowTourScheduling) {
    eventColor = "white";
  } else if (dayType.restricted) {
    eventColor = "#008080";
  } else {
    eventColor = "cyan";
  }
  return eventColor;
}

export const generateDayTypeRequestColor = (approvalStatus) => {
  let eventColor = approvalStatus === "Approved" ? 'cyan' : 'yellow';
  return eventColor;
}

export const generateDayTypeRequestTextColor = (statusComment, dayComment) => {

  let textColor = ((statusComment && statusComment.trim() !== "") || (dayComment && dayComment.trim() !== "")) ? 'red' : 'black';
  return textColor;
}

export const generateResourceDayType = (comment) => {
  let textColor = (comment && comment.trim() !== "") ? 'red'  : 'black';
  return textColor;
}



// WEBPACK FOOTER //
// ./src/Components/DayType/utils/generate-event-color.js